module.exports = __webpack_public_path__ + "img/bg.e3f284e1.png";